module.exports = __webpack_public_path__ + "assets/img/20_50.f6c9eb11.jpg";